import React, { useEffect, useCallback } from 'react';
import './confirmationbox.css';

function ConfirmationBox({ message, handleConfirm }) {
  // Handle Escape key to close
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Escape') {
        handleConfirm(false);
      } else if (e.key === 'Enter') {
        handleConfirm(true);
      }
    },
    [handleConfirm]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div
      className="confirmation-container"
      onClick={(e) => {
        // Close on backdrop click
        if (e.target === e.currentTarget) {
          handleConfirm(false);
        }
      }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirmation-message"
    >
      <div className="confirmation-box">
        <h2 id="confirmation-message">{message}</h2>
        <button
          onClick={() => handleConfirm(true)}
          autoFocus
          aria-label="Confirm action"
        >
          Yes
        </button>
        <button
          onClick={() => handleConfirm(false)}
          aria-label="Cancel action"
        >
          No
        </button>
      </div>
    </div>
  );
}

export default ConfirmationBox;